export default "__VITE_ASSET__BfO7zbSE__"